import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import Footer from "../footer/footer";
import "../notes/third.css";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  }
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Navbar />
      <Link id="back" to="/QuestionBank">
        <Button
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <h1 id="desc" style={{ textAlign: "center" }}>
        Third sem CSE/ISE QB
      </h1>

      <ExpansionPanel
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        style={{ marginTop: "40px" }}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>Mathematics 3</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}> Question Bank <br/>
            <a href="https://drive.google.com/file/d/1SADQs1MMb0nr_7QM9ShRcrFpWMSU5-OD/view?usp=sharing"> Module 1 </a> <br/>
            <a href="https://drive.google.com/file/d/1LY_w4TgjomUOE_OV1gWPiiu59O_-oJSt/view?usp=sharing"> Module 2 </a> <br/>
            <a href="https://drive.google.com/file/d/1iEwQ5fILZYM2i0QvVyWv9yWsfUsXMRPn/view?usp=sharing"> Module 3 </a> <br/>
            <a href="https://drive.google.com/file/d/1g8QDO0Ojr0oBR8KMGfmDwEO7EE_SXFbT/view?usp=sharing"> Module 4 </a> <br/>
            <a href="https://drive.google.com/file/d/1zN8Y5-0--unE9c9UgW3VPOJDJVVD9txh/view?usp=sharing"> Module 5 </a> <br/>
             </div>
          </Typography>

          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1pVQy5RFfCWsd0qvzThhuTb0vxtKe_Z4y/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1Alc7fduKj6gDUjfreU2IHmi86GKNRD9V/view?usp=sharing">
                July 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1XI4a1pL36mpbhBe7HGiGxJ9FH_mcpjNv/view?usp=sharing">
                July 2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ICysZMqAOwAx3F4S-of-uSNaQe_2AeA-/view?usp=sharing"
                target="_blank"
              >
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1CwqNIx2DHZ7uyuBOQwzTIgO5Oebrtn6i/view?usp=sharing"
                target="_blank"
              >
                July 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1g8OAG5nNkjVHL_1Gw0HawYYZ1802PY6u/view?usp=sharing"
                target="_blank"
              >
                Jan 2017
              </a>
              <br />

              <a
                href="https://drive.google.com/file/d/1IheecJsWd6x9lR_sb7HKht2FMnxP0SMG/view?usp=sharing"
                target="_blank"
              >
                July 2017
              </a>
              <br />
             
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>ADE</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              Question Bank <br/>
              <a style={{ color: "black" }} href="https://drive.google.com/file/d/13g1e0oNCLf-w34q1Dssj-800uXe9uE9-/view?usp=sharing " target="_blank">
                Module 1
              </a>
              <br />
              <a style={{ color: "black" }} href=" https://drive.google.com/file/d/11Si1IJE2kEdEraL6q-VoxXYBjZiAP7e0/view?usp=sharing" target="_blank">
                Module 2
              </a>
              <br />
              <a style={{ color: "black" }} href="https://drive.google.com/file/d/1WV8pw6v85gwVEKqZj22vWVJnyNBcirMD/view?usp=sharing " target="_blank">
                Module 3
              </a>
              <br />
              <a style={{ color: "black" }} href="https://drive.google.com/file/d/1TW_Ps-dUorCRkkKfzgeVsdHKHXG6Y70-/view?usp=sharing" target="_blank">
                Module 4
              </a>
              <br />
              <a style={{ color: "black" }} href=" https://drive.google.com/file/d/1sWdMgaS-T_SA5nW6f_E0ThC71rehM9Nu/view?usp=sharing" target="_blank">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1fV05z7rmE3wFh0CGSlg49zO17_PyOCQP/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1Jc9fSCzrV2hzeXddk73W4rYYFlbCtFIE/view?usp=sharing">
               July 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1hDNlnGIUZWztQj5jUn00JNgaVZDhDhTz/view?usp=sharing">
                July 2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1Ur_AUntHWvVupyDS02fncOCRPmrHODJr/view?usp=sharing"
                target="_blank"
              >
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/18TBAQVlL4C1Eb6G2TfzTV2L9X7F0EVOW/view?usp=sharing"
                target="_blank"
              >
                July 2018
              </a>
              <br />

              <a
                href="https://drive.google.com/file/d/16TuSw_xUCsf9w9TqcGBpe3tDrkFKKy0z/view?usp=sharing"
                target="_blank"
              >
                Jan 2017
              </a>
              <br />

              <a
                href="https://drive.google.com/file/d/1seMX3om0qyLWFqKEeOfwYQjZbg7sWrQc/view?usp=sharing"
                target="_blank"
              >
                July 2017
              </a>
              <br />
             
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.heading}>DSC</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
           Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}> Question Bank <br/>
            <a href="https://drive.google.com/file/d/1dnxba2oAp2NqoApqfMvGhzOUc1f_AUTr/view?usp=sharing"> Module (1 & 2) </a> <br/>
            <a href="https://drive.google.com/file/d/1-YWUr_Y-FmxUvPkIuB0CZ8hhMiuuv2x3/view?usp=sharing"> Module 3 </a> <br/>
            <a href="https://drive.google.com/file/d/1aM1w532Y6D5pzEzzepwxUxI6OJT-WNGL/view?usp=sharing"> Module(4 & 5) </a> <br/>
           
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1MXvt4ZxWE55cfbjMkx4cdjSsYy0mo3Ep/view?usp=sharing">
                Jan 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1g3HsPV6cIlEW51te_Q8qeGrSiy58jfmH/view?usp=sharing">
                 July 2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1v6n1KhLb7ejWyn2JU0xQIqqTLLVbmR4T/view?usp=sharing"
                target="_blank"
              >
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ViavMR4BsMPnnoPWQH9YBpEWG5r225Fd/view?usp=sharing"
                target="_blank"
              >
                July 2018
              </a>
              <br />

              <a
                href="https://drive.google.com/file/d/11rpfqR5ga6cdHSrB0aQgQ3wrM5bW8I6J/view?usp=sharing"
                target="_blank"
              >
                Jan 2017
              </a>
              <br />

              <a
                href="https://drive.google.com/file/d/1GECJHWDhF4ICBBNKYpBVuEukltFYhSZ_/view?usp=sharing"
                target="_blank"
              >
                July 2017
              </a>
              <br />
             
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>
            Computer Organisation
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
          Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography> Question Bank <br/>
            <div style={{ color: "black" }}>
            <a href="https://drive.google.com/file/d/1dHBInkrPAfI6fcCZ01EG9uKkt3jKSi_w/view?usp=sharing"> Module 1 </a> <br/>
            <a href="https://drive.google.com/file/d/1QHbrMERYJx8jBXTqdf6U47DTGKgeOAWY/view?usp=sharing"> Module 2 </a> <br/>
            <a href="https://drive.google.com/file/d/18_zXDpVmJ4Xc6YYWGkJja9AViy1JsekY/view?usp=sharing"> Module 3 </a> <br/>
            <a href="https://drive.google.com/file/d/1cwUpjD0kI5M4dd9-voUytRXlk22J0aYJ/view?usp=sharing"> Module 4 </a> <br/>
            <a href="https://drive.google.com/file/d/1WjjWMOuP7hbaVXcZZGPTN4JkBEim8x9w/view?usp=sharing"> Module 5 </a> <br/>
            <a href="https://drive.google.com/file/d/1tc1Tb4CEW4_QeZqKHXodn7NvPQkUQNy_/view?usp=sharing"> All modules </a> <br/>
            </div>

          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1WbOveeFBwGs2WqcQ0QOtiPZ1skanwfWZ/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1lLYVmISYUOCahPb-uZU-cNKiSXATz2Bh/view?usp=sharing">
                July 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1f6-Yu_XWNnoJLNUqaS6bwkH36GlHoa9O/view?usp=sharing">
                July 2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1Bm7Ig8x9TyhxTUG0ouki-2_wdELy-xa_/view?usp=sharing"
                target="_blank"
              >
                Jan 2019 
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1xldg4zv38jeyXP-Iog4wh7Eo7KB1VbPg/view?usp=sharing"
                target="_blank"
              >
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1kHxpWRIrFYZCGnDlck9ziAOenKwWA9K1/view?usp=sharing"
                target="_blank"
              >
                June 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1lY1u5dQkMIqAtGJKc5_6m6hcmR5DHBgG/view?usp=sharing"
                target="_blank"
              >
                Jan 2017
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1L5Q3Cl23cl_y4FUNkWNhwbPr3zeMYOeV/view?usp=sharing"
                target="_blank"
              >
                June 2017
              </a>
              <br />
             
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>
            Unix System Programming
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
         Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography> 
            <div style={{ color: "black" }}> Question Bank <br/> Not Available <br/>
            {/*<a href=""> Module 1 </a> <br/>
            <a href=""> Module 2 </a> <br/>
            <a href=""> Module 3 </a> <br/>
            <a href=""> Module 4 </a> <br/>
  <a href=""> Module 5 </a> <br/> */}
            </div>
          </Typography>
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1o_FCgHsqqWGKt054RwS7Q-PKi06baQJ6/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1KpJT6y5shBLG-vhLNBdERZCQxEpuywkg/view?usp=sharing">
                July 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/18G7QFXzLUbSl5oPHQj5rCiyL0u96No6l/view?usp=sharing">
                Jan 2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1_K08_sG-roLDPBC6psxi3abWW53Qdcbl/view?usp=sharing"
                target="_blank"
              >
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1DVUQObAazKV9gN4-PZFSVtqDD1RHhMtn/view?usp=sharing"
                target="_blank"
              >
                July 2018
              </a>
              <br />

              <a
                href="https://drive.google.com/file/d/11-oP05ye3FRli3TrquK9mHjtJ-rmPO7K/view?usp=sharing"
                target="_blank"
              >
                Jan 2017
              </a>
              <br />

              <a
                href="https://drive.google.com/file/d/1JyL-rGSNbJUszQN0r7lZrDTzVBxdD0cq/view?usp=sharing"
                target="_blank"
              >
                July 2017
              </a>
              <br />
             
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>DMS</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
          Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}> Question Bank <br/> Not available <br/>
            {/* <a href=""> Module 1 </a> <br/>
            <a href=""> Module 2 </a> <br/>
            <a href=""> Module 3 </a> <br/>
            <a href=""> Module 4 </a> <br/>
<a href=""> Module 5 </a> <br/> */}
            </div>
          </Typography>
          
          <Typography style={{ marginLeft: "30px" }}>
            <div style={{ color: "black" }}>
            Previous year Question Papers <br />
              <a href="https://drive.google.com/file/d/1tdA3AaIA3AqglWT_XWw1lv5q0_Eh3XLS/view?usp=sharing">
                Jan 2019
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/1GWQgLeK6amfjSzWmJQnIx_shrYRT3wfc/view?usp=sharing">
                July 2019
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1DRsxahRQqATe8sHGCkqHwvhmID4GW_6u/view?usp=sharing">
                July 2019
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1IdjRoziK9mk5w0QboGy_XGDxH4EfHyYN/view?usp=sharing"
                target="_blank"
              >
                Jan 2018
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1g-VNymB6ELhUhDp-w4vFrkYFQLUJNqgG/view?usp=sharing"
                target="_blank"
              >
                July 2018
              </a>
              <br />

              <a
                href="https://drive.google.com/file/d/1Hw5bikS-UxooUi_nZxgpBF5b453k78Ok/view?usp=sharing"
                target="_blank"
              >
                Jan 2017
              </a>
              <br />

              <a
                href="https://drive.google.com/file/d/1puwGSaoW4Vkpuf5D8JyeB7jVHAlpZYgk/view?usp=sharing"
                target="_blank"
              >
                July 2017
              </a>
              <br />
             
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
     

      <Footer />
    </div>
  );
}
